import AddressesActionTypes from './addresses-types'

/***************  Address Subscriptions  ****************/

export const startGetAddressesSubscriptions = data => ({
    type: AddressesActionTypes.START_GET_ADDRESSES_SUBSCRIPTIONS,
    payload: data,
})
export const successGetAddressesSubscriptions = data => ({
    type: AddressesActionTypes.SUCCESS_GET_ADDRESSES_SUBSCRIPTIONS,
    payload: data,
})
export const startBuyAddressSubscription = data => ({
    type: AddressesActionTypes.START_BUY_ADDRESS_SUBSCRIPTION,
    payload: data,
})
export const successBuyAddressSubscription = data => ({
    type: AddressesActionTypes.SUCCESS_BUY_ADDRESS_SUBSCRIPTION,
    payload: data,
})
export const finishBuyAddressSubscription = data => ({
    type: AddressesActionTypes.FINISH_BUY_ADDRESS_SUBSCRIPTION,
    payload: data,
})
export const failureBuyAddressSubscription = data => ({
    type: AddressesActionTypes.FAILURE_BUY_ADDRESS_SUBSCRIPTION,
    payload: data,
})
export const startChangeShippingAddress = data => ({
    type: AddressesActionTypes.START_CHANGE_SHIPPING_ADDRESS,
    payload: data,
})
export const successChangeShippingAddress = data => ({
    type: AddressesActionTypes.SUCCESS_CHANGE_SHIPPING_ADDRESS,
    payload: data,
})
export const finishChangeShippingAddress = data => ({
    type: AddressesActionTypes.FINISH_CHANGE_SHIPPING_ADDRESS,
    payload: data,
})
export const failureChangeShippingAddress = data => ({
    type: AddressesActionTypes.FAILURE_CHANGE_SHIPPING_ADDRESS,
    payload: data,
})

/***************  VerifyProofOfAddress ****************/
export const startVerifyPrimaryAddress = data => ({
    type: AddressesActionTypes.START_VERIFY_PRIMARY_ADDRESS,
    payload: data,
})
export const successVerifyPrimaryAddress = data => ({
    type: AddressesActionTypes.SUCCESS_VERIFY_PRIMARY_ADDRESS,
    payload: data,
})
export const finishVerifyPrimaryAddress = data => ({
    type: AddressesActionTypes.FINISH_VERIFY_PRIMARY_ADDRESS,
    payload: data,
})
export const failureVerifyPrimaryAddress = data => ({
    type: AddressesActionTypes.FAILURE_VERIFY_PRIMARY_ADDRESS,
    payload: data,
})
